import { useCookieConsentOptional } from "../context/CookieConsentContext";
import { hasOptionalTrackingServices } from "../lib/cookieConsent";

export default function CookiePreferencesTrigger({ className = "" }) {
  const consentContext = useCookieConsentOptional();

  if (!hasOptionalTrackingServices() || !consentContext) return null;

  return (
    <button
      type="button"
      className={className || "jw-cookie-preferences-trigger"}
      onClick={consentContext.openPreferences}
    >
      Cookie settings
    </button>
  );
}
